export default __webpack_public_path__ + "static/media/privacy.4442109c.svg";